import { IGetInfrastructureV4Response } from 'shared/common/repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4Response';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectInfrastructureApiResult(state: TApplicationState): IGetInfrastructureV4Response | null {
  return state.infrastructure.data;
}
